const mutations = {
  SET_USER: (state, user) => {
    state.user = user;
  },
  REFRESH: (state) => {
    state.refresh = new Date();
  },
  SET_ACCESS_TOKEN: (state, token) => {
    state.accessToken = token;
  },
  RESET_USER: (state) => {
    state.user = {};
    state.accessToken = null;
  },
};

export default mutations;
